import requests from "./httpService";

const VehicleCategoryServices = {
  getAllVehicleCategory: async (body) => {
    return requests.get(`/vehicleCategory/`);
  },

  addVehicleCategory: async (body) => {
    return requests.post(`/vehicleCategory/add`, body);
  },
  getVehicleCategoryById: async (id) => {

    return requests.get(`/vehicleCategory/${id}`);
  },
  getVehicleCategoryByTypeID: async (VehicleId) => {
    return requests.get(`/vehicleCategory/vehicles/type/${VehicleId}`);
  },
  updateVehicleCategory: async (id, body) => {
    return requests.put(`/vehicleCategory/update/${id}`, body);
  },

  deleteVehicleCategory: async (id) => {
    return requests.delete(`/vehicleCategory/delete/${id}`);
  },
};

export default VehicleCategoryServices;
